<div class="action">
	<div class="user" *ngIf="gameUser">
		{{ gameUser.gameUserNumber }}
    <ng-container *ngIf="!gameUser.tournamentTeamUser.id">
		  {{ gameUser.teamUser.user.lastName }} {{ gameUser.teamUser.user.firstName.substr(0,1) }}.
    </ng-container>
    <ng-container *ngIf="gameUser.tournamentTeamUser.id">
      {{ gameUser.tournamentTeamUser.leaguePlayer.lastName }} {{ gameUser.tournamentTeamUser.leaguePlayer.firstName.substr(0,1) }}.
    </ng-container>
	</div>
	<div class="user" *ngIf="!gameUser && gameLog.logType !== gameLogTypes.timeout">Не заявленный игрок</div>
	<div class="type">
		{{ gameLog.logType | localization: gameLogTypeLocalization }}
	</div>
</div>
<div class="center">
	<div class="circle"></div>
</div>
<div class="action"></div>
